import { render, staticRenderFns } from "./Cancompete.vue?vue&type=template&id=ecac2d94&scoped=true&"
import script from "./Cancompete.vue?vue&type=script&lang=js&"
export * from "./Cancompete.vue?vue&type=script&lang=js&"
import style0 from "./Cancompete.vue?vue&type=style&index=0&id=ecac2d94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecac2d94",
  null
  
)

export default component.exports